export default __webpack_public_path__ + "static/media/(22).a082dd92.jpg";